import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import clsx from "clsx";
import Loader from "../../../components/Loader";
import { useTranslation } from "react-i18next";
import { DIALING_CODE, CLEVERTAP_EVENTS, NAVIGATION_ROUTES } from "../../../constant";
import { toast, Id } from "react-toastify";
import Toast from "../../../components/Toast/toast";
// import { useConfigStore } from '../../../storage/configState';
// import { DEFAULT_NUMBER_VALIDATION, LOGIN_INPUT_REGEX, SIGN_UP_ACTION } from '../../../appConstants/AppConstant';
// import { isEmpty } from 'lodash';
import { requestOtp } from "../../../api/useRequestOtpApi";
import { useTokenStore } from "../../../storage/tokenState";
import { GOOGLE_LOGIN_KEY, SIGN_UP_ACTION } from "../../../appConstants/AppConstant";
import { useConfigStore } from "../../../storage/configState";
import zupeeLogo from "../../../assets/zupee-icon.svg";
import ImageComponent from "../../../components/ImageComponent";
import alertLineIcon from "../../../assets/alert-line.svg";
import { debounce } from "lodash";
import { useAuthenticateUserApi } from "../../../api/useAuthApi";
import { getPartnerId } from "../../../utils/helpers/common";
import { SCREEN_NAMES } from "../../../utils/helpers/constants";
import { _isEmpty } from "../../../utils/helpers/zupeeLodash";
import { pushClevertapEvent } from "../../../utils/analytics/clevertap";

const SignIn: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const {state} = location;
  const navigate = useNavigate();
  const { language } = useTokenStore();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isDeclarationChecked, setIsDeclarationChecked] = useState(true);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const toastId = useRef<Id>();
  const { preSignupConfig } = useConfigStore();
  const {loginSkipConfig} = preSignupConfig || {};
  const authContentBoxRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const partnerImageUrl =
    preSignupConfig?.pwaConfig?.partnerSignupScreenImageUrl || zupeeLogo;
    const action = SIGN_UP_ACTION;

    const { refetch, isLoading, error } = useAuthenticateUserApi(
      mobileNumber as string,
      action as string,
      language,
      true,
      // otp.join(''),
      undefined,
      getPartnerId(),
      SCREEN_NAMES.SIGNUP,
      sessionStorage.getItem("GOOGLE_LOGIN_KEY") || undefined
    );

  

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const windowHeight = window.innerHeight;

      if (viewportHeight < windowHeight && buttonRef.current) {
        // Keyboard is open, scroll button into view
        buttonRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    };

    window.visualViewport?.addEventListener('resize', handleResize);
    window.addEventListener('resize', handleResize);

    // Focus input after a short delay
    const focusTimer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 300);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', handleResize);
      clearTimeout(focusTimer);
    };
  }, []);

  // const { preSignupConfig } = useConfigStore();
  // const signupConfig = preSignupConfig?.signupConfig;
  // const numRegexConfig =
  //   signupConfig?.phoneNumberLoginConfig?.numberValidationRegex ||
  //   DEFAULT_NUMBER_VALIDATION;

  // const numberValidationRegex = useMemo(() => new RegExp(numRegexConfig), [numRegexConfig],);

  const mobilePattern = useMemo(() => /^[0-9]{10}$/, []);

  const showToastError = useCallback((message: string) => {
    if (!toastId.current || !toast.isActive(toastId.current)) {
      toastId.current = toast.error(message);
    }
  }, []);

  const handleMobileInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setMobileNumber(value);

      if (!mobilePattern.test(value) && value.length === 10) {
        if (!toastId.current || !toast.isActive(toastId.current)) {
          toastId.current = toast.error(t("invalidMobileNumberError"));
          setErrorMessage(t("invalidMobileNumberError"));
        }
        setIsButtonEnabled(false);
      } else {
        if (!toastId.current || !toast.isActive(toastId.current)) {
          toast.dismiss(toastId.current);
        }
        setIsButtonEnabled(mobilePattern.test(value) && isDeclarationChecked);
        setErrorMessage("");
      }
    },
    [isDeclarationChecked, mobilePattern, t]
  );

  const handleCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked = e.target.checked;
      setIsDeclarationChecked(isChecked);
      setIsButtonEnabled(mobilePattern.test(mobileNumber) && isChecked);

      if (!isChecked) {
        showToastError(t("acceptTermsError"));
      }
    },
    [mobileNumber, mobilePattern, t, showToastError]
  );

  const onGetOtp = useCallback(
    debounce(async () => {
      toast.dismiss(toastId.current);
      const getOtp = async () => {
        try {
          setLoading(true);
          setErrorMessage("");
          const response = await requestOtp(
            mobileNumber,
            SIGN_UP_ACTION,
            false,
            language
          );
          if (response?.success) {
            toast.success(t("otpSentSuccessfully"));
            navigate(
              `${NAVIGATION_ROUTES.OTP}/${mobileNumber}/${SIGN_UP_ACTION}`, {state}
            );
          } else {
            const error = response?.error;
            showToastError(error || t("someThingWentWrong"));
            setErrorMessage("error");
            // handleErrorMsg(error); //TODO this error will be string fi Typescript from origin
          }
        } catch (error: any) {
          // toast.error(error?.message);
          showToastError(error?.message);
          // handleErrorMsg(error.message);
        } finally {
          setTimeout(() => setLoading(false), 100);
        }
      };

      await getOtp();
    }, 200),
    [language, mobileNumber, t, navigate, showToastError]
  );

  // Clevertap Event
  const handleClickCTEvent = useCallback(() => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_PHONE_PROCEED);
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      if (!mobilePattern.test(mobileNumber)) {
        showToastError(t("invalidMobileNumberError"));
        return;
      }

      // setLoading(true);
      if(loginSkipConfig?.enabled){
        if(!_isEmpty(sessionStorage.getItem(GOOGLE_LOGIN_KEY))){
          refetch();
        }
      } else {
        onGetOtp();
        handleClickCTEvent();
        // Push profile to CleverTap
        // pushCleverTapProfile(mobileNumber);
      }
    },
    [mobilePattern, mobileNumber, loginSkipConfig?.enabled, showToastError, t, refetch, onGetOtp, handleClickCTEvent]
  );

  // Dismissing sign-in returns to the landing page, which is the wallet.
  const handleByPass = useCallback(() => {
    setLoading(true);
    setTimeout(() => {
      navigate(NAVIGATION_ROUTES.WALLET);
      setLoading(false);
    }, 1000);
  }, [navigate]);

  // if (loading) return <Loader />;

  return (
    <>
      {loading && <Loader transparent/>}
      
      <div className={clsx(styles.signinContainer, "authPageContainer")} >
        {/* <div
          className={clsx(styles.skipBtn, "skipBtn fontSizeXs fontWeightBold")}
          onClick={handleByPass}
        >
          {t("skip")}
        </div> */}
        <div className={clsx(styles.contentBox, "authContentBox")} ref={authContentBoxRef}>
          <div className={clsx(styles.crossBtn)} onClick={handleByPass}>
            &#10005;
          </div>
          <div className={clsx(styles.partnerImage)}>
            <ImageComponent src={partnerImageUrl} alt="brand logo" />
          </div>
          <div
            className={clsx(styles.pageHeading, "fontSizeMd", "fontWeightBold")}
          >
            {t("enterPhoneNumberToContinue")}
          </div>
          <form onSubmit={handleSubmit}>
            <div
              className={clsx(
                styles.inputFieldBlock,
                `${errorMessage && styles.error}`
              )}
            >
              <div
                className={clsx(
                  styles.prefixBox,
                  "fontSizeSm fontWeightRegular"
                )}
              >
                {DIALING_CODE}
              </div>
              <input
                className={clsx(
                  styles.inputBox,
                  "fontSizeSm fontWeightRegular"
                )}
                type="tel"
                ref={inputRef}
                value={mobileNumber}
                onChange={handleMobileInputChange}
                placeholder={t("phoneNumberPlaceholder")}
                maxLength={10}
                required
              />
              {errorMessage && (
                <ImageComponent
                  className={styles.inputAlertIcon}
                  src={alertLineIcon}
                  alt=""
                />
              )}
            </div>
            <button
              className={clsx(styles.submitBtn, "btn primaryBtn")}
              type="submit"
              disabled={!isButtonEnabled}
              ref={buttonRef}
            >
              {t("continue")}
            </button>
            <div className={clsx(styles.declarationBlock)}>
              <label
                className={clsx(
                  styles.declarationLabel,
                  "fontSizeXs fontWeightRegular"
                )}
              >
                <input
                  className={clsx(styles.declarationCheckbox)}
                  type="checkbox"
                  checked={isDeclarationChecked}
                  onChange={handleCheckboxChange}
                />
                {t("iAcceptThe")}
                <NavLink
                  to={ NAVIGATION_ROUTES.EXTERNAL_LINKS}
                  state={{ url: `${process.env.REACT_APP_MAIN_SITE_LINK}/terms-and-conditions/` }}
                  className={clsx(styles.linkText, "fontWeightBold")}

                >
                  {t("t&cLabel")}
                </NavLink>
              </label>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SignIn;
